import { locale } from "../../lib/i18n";

export const MEMBER_PALETTE = ["#10b981", "#3b82f6", "#f59e0b", "#a855f7", "#ec4899", "#0ea5e9", "#f97316", "#14b8a6"];

export const EVENT_TYPES = [
  { value: "meeting", label: "Meeting" },
  { value: "call", label: "Call" },
  { value: "match", label: "Match" },
  { value: "training", label: "Training" },
  { value: "trial", label: "Trial" },
  { value: "media", label: "Media" },
  { value: "contract_deadline", label: "Contract deadline" },
  { value: "renewal", label: "Renewal" },
  { value: "transfer_window", label: "Transfer window" },
  { value: "other", label: "Other" },
];

export const TYPE_PILL = {
  training: "pm-pill-blue", trial: "pm-pill-amber", media: "pm-pill-slate", match: "pm-pill-green",
  contract_deadline: "pm-pill-red", transfer_window: "pm-pill-amber", renewal: "pm-pill-green",
  call: "pm-pill-blue", meeting: "pm-pill-slate", other: "pm-pill-slate",
};

export function startOfWeek(d) {
  const out = new Date(d);
  const day = out.getDay();
  out.setDate(out.getDate() + ((day === 0 ? -6 : 1) - day));
  out.setHours(0, 0, 0, 0);
  return out;
}
export function addDays(d, n) {
  const out = new Date(d);
  out.setDate(out.getDate() + n);
  return out;
}
export function toLocalInput(iso) {
  if (!iso) return "";
  const d = new Date(iso);
  const pad = (n) => String(n).padStart(2, "0");
  return `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())}T${pad(d.getHours())}:${pad(d.getMinutes())}`;
}
export function fromLocalInput(v) {
  return v ? new Date(v).toISOString() : null;
}
export function fmtTime(iso) {
  return new Date(iso).toLocaleTimeString(locale(), { hour: "2-digit", minute: "2-digit" });
}
export function fmtDayLong(iso) {
  return new Date(iso).toLocaleDateString(locale(), { weekday: "short", day: "2-digit", month: "short", hour: "2-digit", minute: "2-digit" });
}
export function memberColor(members, userId) {
  const idx = members.findIndex((m) => m.user_id === userId);
  return MEMBER_PALETTE[(idx < 0 ? 0 : idx) % MEMBER_PALETTE.length];
}
